<!--
 * @Author: lixiaodi
 * @Date: 2020-03-18 09:29:35
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-06-23 19:29:33
 -->
<template>
   <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, prev, pager, next"
        :total="total"
        :page-size="size"
        style="text-align: center;margin: .1rem 0;"
        next-click="onNextClick">
    </el-pagination>
</template>

<script>
export default {
    name: 'Pagination',
    props: ['total','size'],
    data() {
        return {
            currentPage: 1
        }
    },
    methods: {
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
        },
        // 下一页
        onNextClick (e){
            // console.log(e,'点击下一页');
        }
    }
}
</script>
<style lang="stylus" scoped>
.wrapper{
    // position: absolute;bottom: 0;left: 33%;
}
</style>


// WEBPACK FOOTER //
// src/components/Education/commonView/Pagination.vue